import React, { FunctionComponent, Props } from 'react';
import ReactPaginate from 'react-paginate';

export interface IconButtonProps {
  style?: Object;
}

const IconButton: FunctionComponent<IconButtonProps> = ({ style }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="10"
    height="14"
    viewBox="0 0 10 14"
    style={style}
  >
    <path d="M7,0l7,10.5H0Z" transform="translate(10) rotate(90)" />
  </svg>
);

export interface PaginateProps {
  initialPage?: number;
  pageCount: number;
  marginPagesDisplayed?: number;
  pageRangeDisplayed?: number;
  hrefBuilder?: (pageIndex: number) => void;
  onPageChange: (selectedItem: { selected: number }) => void;
}

export const Paginate: FunctionComponent<PaginateProps> = ({
  initialPage,
  pageCount,
  hrefBuilder,
  onPageChange,
  marginPagesDisplayed,
  pageRangeDisplayed,
}) => (
  <ReactPaginate
    previousLabel={<IconButton style={{ transform: 'rotate(180deg)' }} />}
    previousClassName="pagination__item"
    previousLinkClassName="pagination__link"
    nextLabel={<IconButton />}
    nextClassName="pagination__item"
    nextLinkClassName="pagination__link"
    breakLabel={'...'}
    breakClassName="pagination__item"
    breakLinkClassName="pagination__link"
    pageCount={pageCount}
    marginPagesDisplayed={marginPagesDisplayed}
    pageRangeDisplayed={pageRangeDisplayed}
    onPageChange={onPageChange}
    initialPage={initialPage}
    disableInitialCallback
    containerClassName="pagination justify-content-center justify-content-md-end mt-4"
    pageClassName="pagination__item"
    pageLinkClassName="pagination__link"
    activeLinkClassName="pagination__link--active"
    hrefBuilder={hrefBuilder}
  />
);

Paginate.defaultProps = {
  marginPagesDisplayed: 1,
  pageRangeDisplayed: 2,
};

export default Paginate;
